import { identity, pipe } from 'fp-ts/lib/function';
import * as E from 'fp-ts/lib/Either';

export const parseJson = <T>(s: string): E.Either<SyntaxError, T> =>
  pipe(
    E.tryCatch(() => JSON.parse(s), identity),
    E.mapLeft(() => new SyntaxError('Invalid JSON')),
    E.map((value) => value as T)
  );
